import { render, staticRenderFns } from "./recallRecord.vue?vue&type=template&id=b0246db6&scoped=true&"
import script from "./recallRecord.vue?vue&type=script&lang=js&"
export * from "./recallRecord.vue?vue&type=script&lang=js&"
import style0 from "./recallRecord.vue?vue&type=style&index=0&id=b0246db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0246db6",
  null
  
)

export default component.exports